import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { activeUser } from "../../Store/Slices/APIs";
import { PauseButton, PlayButton } from "../../Assets/svg";
import AddToPlaylistButton from "../../Components/BottomPlayerBar/Playlist/AddToPlaylistButton";
import { getPlaylistConfig, getPlaylistType, getRandomTrackId, InitPlaylistTrackingIds, SetPlaylistTrackId, setTrackIdToRandomList } from "../../Util/helpers";
import {
  addPlaylistTracks,
  playAllTracks,
  removeAllTracks,
  setConfig,
  setSelectedId,
  setSelectedItem,
  setSelectedName,
  setSelectedType,
  setShareSystemCreatedPlaylist,
  togglePlayPause,
} from "../../Store/Slices/PlayerSlice";
import { handleEditPlaylistModal, handleRemovePlaylistModal, handleSaveMixModal, handleShareMixModal } from "../../Store/Slices/ModalSlice";
import { handleMixTrayGlobal, setMixSavedId } from "../../Store/Slices/SaveMixSlice";

const PlaylistStrip = ({ item }) => {

  const dispatch = useDispatch();

  const isPlaying = useSelector((state) => state.player.isPlaying);
  const config = useSelector((state) => state.player.config);
  const tracks = useSelector((state) => state.player.playingTracks);
  const flattenTracks = item.tracks;


  const playlist_config = {
    id: item?.id,
    name: item?.name,
    data: getPlaylistConfig(flattenTracks),
    isSavedPlaylist: true,
    playlist_type: getPlaylistType(flattenTracks[0]),
    system_created_playlist: item?.system_created_playlist ?? false
  };

  const [isSelected, setIsSelected] = useState(false);


  useEffect(() => {
    if (config?.type === "playlist") {
      setIsSelected(config["id"] === item.id);
    } else {
      setIsSelected(tracks.some((t) => t.id === item.id));
    }
  }, [tracks, item.id]);

  const handlePlayPause = () => {
    if (!isSelected) {
      const data = flattenTracks;

      if (flattenTracks.length === 0) return;

      // activate user
      dispatch(activeUser());
      dispatch(removeAllTracks());
      // set the playing config for player
      dispatch(
        setConfig({
          id: item?.id,
          type: "playlist",
          playlist_type: item?.playlist_type ?? 'default',
          name: item?.name,
          data: data,
          playingId: data[0]?.id,
          restartId: null,
          isRepeat: false,
          isShuffle: false,
          isPlaylist: false,
          isPlaylistMix: false,
        })
      );

      setTimeout(() => {
        InitPlaylistTrackingIds(data[0]?.id);
        dispatch(addPlaylistTracks({ data }));
        dispatch(setSelectedId(item.id));
        dispatch(setSelectedItem(data));
        dispatch(playAllTracks(true));
        dispatch(handleMixTrayGlobal(true));
      });
    } else {
      dispatch(togglePlayPause());
    }
  };


  const handleOnChange = ({ id, event }) => {

    switch (event) {
      case "remove-playlist":
        dispatch(setSelectedId(item.id));
        dispatch(setSelectedItem(flattenTracks));
        dispatch(handleRemovePlaylistModal(true));
        break;
      case "edit-playlist":
        dispatch(setSelectedId(item.id));
        dispatch(setSelectedName(item.name));
        dispatch(setSelectedItem(flattenTracks));
        dispatch(setShareSystemCreatedPlaylist(item?.system_created_playlist ?? false));
        dispatch(handleEditPlaylistModal(true));
        break;
      case "add-to-mixes":
        const obj = {
          playlist_type: item?.playlist_type,
        }
        dispatch(setConfig(obj));
        dispatch(setSelectedType('playlist'));
        dispatch(setSelectedItem(flattenTracks));
        dispatch(handleSaveMixModal(true));
        break;
      case "share-playlist":
        dispatch(setMixSavedId(item.id));
        dispatch(setShareSystemCreatedPlaylist(item?.system_created_playlist ?? false));
        dispatch(setSelectedItem(flattenTracks))
        dispatch(handleShareMixModal(true));
        break;
      default:
        break;
    }

  };



  return (
    <>
      <div className="mixer-pallete mb-2 mb-sm-3 p-2 p-sm-2">
        <button className="btn p-2 mx-sm-3 me-sm-4" onClick={handlePlayPause}>
          <img
            src={isPlaying && isSelected ? PauseButton : PlayButton}
            className="play-icon"
          />
        </button>
        <div className="mixer-gradient">
          {flattenTracks?.slice(0, 3)?.map((item, index) => (
            <div className="mixerSoundThumbnail" key={index}>
              <img src={item?.image} alt={item?.name} />
            </div>
          ))}
        </div>
        <div className="flex-grow-1">
          <h5 className="mb-0 ps-3 ps-sm-4 fw-light mixer-name">
            {item?.name}
          </h5>
        </div>
        <AddToPlaylistButton
          config={playlist_config}
          onChange={handleOnChange}
        />
      </div>


    </>
  );
};

export default PlaylistStrip;
